module.exports = __webpack_public_path__ + "fonts/interactive.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/interactive.svg
// module id = 57
// module chunks = 0